<template>
  <div class="main-content">
    <SectionTitle class="animate-target" v-animate-in :title="title"></SectionTitle>
    <div class="ctn-t1 animate-target" v-animate-in>CONFIDENCE STUDY (N=818)</div>
    <div class="ctn-t2 animate-target" v-animate-in>Multicentre, randomised, controlled, double-blind, 3-armed, phase 2 study<sup>1</sup></div>
    <img class="ctn-image animate-target" v-animate-in src="../../assets/images/p3-11/3-11-1.png" />
    <div class="ctn-text">
      <div class="ct-1 animate-target" v-animate-in>
        <div>Primary endpoints​</div>
        <div>
          <p>Relative change in UACR from baseline to day 180 in:​</p>
          <ul>
            <li>Empagliflozin vs combination</li>
            <li>Finerenone vs combination</li>
          </ul>
        </div>
      </div>
      <div class="ct-1 animate-target" v-animate-in>
        <div>Key inclusion criteria​​</div>
        <div>
          <ul>
            <li>eGFR 30 to 90 mL/min/1.73 m<sup>2*</sup>​</li>
            <li>UACR ≥100 to <5000 mg/g (≥11.3 to <565 mg/mmol)​</li>
            <li>T2D with HbA1c <11%​</li>
            <li>Clinically maximum-tolerated dose of ACEi/ARB for >1 month</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="ctn-t4 animate-target" v-animate-in>Combination of finerenone with simultaneous initiation of Finerenone and SGLT2i</div>
    <div class="ctn-t3 animate-target" v-animate-in>People experienced an early and additive reduction in UACR of up to 52% from baseline<sup>1</sup></div>
    <div ref="target" class="show_animation animate-target" v-animate-in>
      <img src="../../assets/images/p3-11/chart.svg" />
      <img src="../../assets/images/p3-11/line.svg" />
      <img src="../../assets/images/p3-11/num.svg" />
    </div>
    <img class="ctn-image animate-target" v-animate-in src="../../assets/images/p3-11/3-11-3.png" />
    <GoNext class="animate-target" v-animate-in href="/section3/3-12">Next</GoNext>
    <ContentNotice class="animate-target" v-animate-in :txt="noticeTxt"/>
  </div>
</template>

<script>
import SectionTitle from "../../components/SectionTitle";
import GoNext from "../../components/GoNext";
import ContentNotice from "../../components/ContentNotice";
import {mapState} from "vuex";
export default {
  name: "s3-11",
  components: {SectionTitle, GoNext, ContentNotice},
  computed:{
  },
  data(){
    return{
      noticeTxt:"*Finerenone was initiated at 10 mg OD: eGFR ≥25 to <60 mL/min/1.73 m²; 20 mg OD: eGFR ≥60 mL/min/1.73 m²<sup>.1</sup><br/><div class='brs'></div>"
      +"ACEi, angiotensin-converting enzyme inhibitor; ADA, American Diabetes Association; ARB, angiotensin receptor blocker; CI, confidence interval; CKD, chronic kidney disease; eGFR, estimated glomerular filtration rate; HbA1c, glycated haemoglobin; LS, least-squares; R, randomised; SGLT2i, sodium-glucose cotransporter 2 inhibitor; T2D, type 2 diabetes; UACR, urine albumin-to-creatinine ratio.<br/><div class='brs'></div>"
      +"References:<br/><div class='brs'></div>"
      +"1. Agarwal R, et al. N Engl J Med. 2025:1-11. doi:10.1056/NEJMoa2410659.<br/>"
      +"2. American Diabetes Association (Section 11: Chronic kidney disease and risk management: standards of care in diabetes). Diabetes Care. 2024;47(Suppl 1):S219-S230. doi:10.2337/dc24-S011.",
      title:"<div class='h-image'><img class='title-logo' src='"+require('../../assets/images/p3-title-icon.png')+"' /><p>CONFIDENCE investigated the combination of finerenone and SGLT2i in chronic kidney disease and type 2 diabetes<sup>1</sup></p></div>"
    }
  },
  mounted() {
    this.initClassObserver(); // 组件挂载后初始化监听
  },
  beforeDestroy() {
    this.destroyObserver(); // 组件卸载前销毁监听
  },
  methods: {

    initClassObserver() {
      const targetEl = this.$refs.target;
      if (!targetEl) return;

      this.observer = new MutationObserver((mutations) => {
        console.log(mutations);
        const mutation = mutations[0];
        if (mutation.attributeName === 'class') {
          targetEl.children[1].classList.add('extend2')
          targetEl.children[2].classList.add('fadeIn')
        }
      });

      const config = {
        attributes: true,
        attributeFilter: ['class'],
        attributeOldValue: true,
      };

      this.observer.observe(targetEl, config);
    },

    // 销毁观察者（避免内存泄漏）
    destroyObserver() {
      if (this.observer) {
        this.observer.disconnect(); // 断开监听
        this.observer = null; // 清空实例
      }
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/section3/s3.css";
.ctn-t1 {
  color: #10384F;
  font-size: 24px;
  font-weight: bold;
  margin-top: 40px;
}
.ctn-t2 {
  color: #10384F;
  font-size: 20px;
}
.ctn-t3 {
  color: #10384F;
  font-size: 24px;
  font-weight: bold;
  margin-top: 10px;
}
.ctn-t4 {
  color: #10384F;
  font-size: 20px;
  margin-top: 40px;
}
.ctn-image {
  width: 100%;
  margin-top: 40px;
}
.ctn-text {
  display:flex;
  gap: 40px;
}
.ctn-text .ct-1 {
  width:calc(100% - 20px);
}
.ctn-text .ct-1 div:nth-child(1) {
  font-weight:bold;
}
.ctn-text .ct-1 div:nth-child(2) p {
  margin-top: 10px;
}
.ctn-text .ct-1 div:nth-child(2) ul {
  padding-left: 20px;
  margin-top:10px;
}

.show_animation {
  position:relative;
  width: 100%;
  margin-top: 40px;
}
.show_animation img {
  width: 100%;
}
.show_animation img:nth-child(2) {
  position:absolute;
  height: 100%;
  bottom:0px;
  left:0px;
  width:0%;
  object-fit: cover;
  object-position: left;
}
.show_animation img:nth-child(3) {
  position:absolute;
  width: 100%;
  bottom:0px;
  left:0px;
  object-fit: cover;
  object-position: bottom;
  opacity: 0;
}
</style>
